import React from 'react'
import { RbiLandingLinksFetcher } from '../assets/helpers/RbiLandingLinksFetcher'

const MarQueeText = () => {
    const styles = {
        movingtext: {
            animation: "moveLeft 24s linear infinite",
            color: "white",
            whiteSpace: "nowrap",
            fontSize: "16px",
            position: "absolute",
            width: "100%",
            top: "-2px"
        }
    }
    const data = RbiLandingLinksFetcher()
    return (
        <div className='col-lg-12'><p style={styles.movingtext}>{data?.marqueeTextEn}</p></div>
    )
}

export default MarQueeText